import { MappedClass, MappedProperty, MappedPropertyDate } from '@h5s/util-object';

import { DateTime } from 'luxon';

@MappedClass()
export class GetIstatCustomerRequest {
  @MappedProperty()
  ownerIstatId: number;

  @MappedProperty()
  year: number | null;

  @MappedProperty()
  month: number | null;

  @MappedPropertyDate()
  referenceDate: DateTime | null;

  @MappedPropertyDate()
  beginDate: DateTime | null;

  @MappedPropertyDate()
  endDate: DateTime | null;

  constructor(init?: Partial<GetIstatCustomerRequest>) {
    Object.assign(this, init);
  }
}
